module.exports = __webpack_public_path__ + "static/media/testmonial_03.5ff345cc.png";